{
  "appointment-details-page": {
    "buttons": {
      "book-new-appointment": "Đặt lịch hẹn mới"
    },
    "meta": {
      "title": "Chi tiết lịch hẹn",
      "description": "Mọi thông tin về lịch hẹn"
    }
  }
}
